import { __decorate, __metadata } from "tslib";
import { IsEnum, IsOptional, IsUUID } from 'class-validator';
import { PagedQuery } from '../core';
import { LocationStatus } from './LocationStatus';
export class ListLocationsByStatus extends PagedQuery {
    constructor(courtSystemId, page, status, parentId) {
        super(page);
        this.courtSystemId = courtSystemId;
        this.status = status;
        this.parentId = parentId;
    }
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], ListLocationsByStatus.prototype, "courtSystemId", void 0);
__decorate([
    IsOptional(),
    IsEnum(LocationStatus),
    __metadata("design:type", String)
], ListLocationsByStatus.prototype, "status", void 0);
__decorate([
    IsOptional(),
    IsUUID(),
    __metadata("design:type", String)
], ListLocationsByStatus.prototype, "parentId", void 0);
